import { Outlet } from 'react-router-dom';

import { SiteFooter, SiteHeader } from '@/components/marketing';

/**
 * The dark shell the marketing pages live in.
 *
 * Separate from PublicLayout rather than a mode of it: the header here is
 * transparent and sits *over* the page so the hero gradient can run to y=0
 * behind it, which means `main` cannot have a header above it in the flow.
 * PublicLayout's sticky bar and light surface still serve the auth screens and
 * the internship browser, which have no dark design yet.
 */
export function MarketingLayout() {
  return (
    <div className="bg-night text-on-night flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
